
        import 'IamModal.9965fb4.css-module'
        export default {"IamModal":"IamModal_IamModal_9965fb4"}
    